export function capitalize(source: string) {
  if (!source) return source;

  const str = source.toString();

  return str[0].toUpperCase() + str.slice(1);
}
